<template>

<v-card  class="ma-0 pa-0" style="width:100%; background-color: #FAFAFA;">
  <v-layout row class=" primary pl-2 pr-2 " style="">
                          <v-flex  xs12 sm12 offset-sm2 class=" mr-3 ml-3 white hidden-md-and-up ">
                              <h3 class="mb-1" style="color:grey">  &nbsp; Edit Artefact   </h3>
                          </v-flex>
                      </v-layout>
  <v-container class="mt-2 pt-2" style="">
      
      <v-layout justify-center>
          <v-flex xs12 md10 offset-md1 class="ma-1 " >
              <v-form @submit.prevent="onUpdateArtefact" ref="form" >
                <v-layout elevation-1 class="white" style="box-shadow: 0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12);" wrap>
                <v-flex xs12 md4 style=" border-right:1px solid #eeeeee ">

                  <h3 class="hidden-sm-and-down pl-2 mb-0" style="color:grey; height:67px">Edit Artefact</h3>
                <div>
                  
                  <v-divider></v-divider>
                  <v-layout row  class="mt-2  pl-2 pr-2 pt-2 pb-2 ">
                      <v-flex xs12 sm12 class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : formUpload.mainImg[0].status }"
                                        :loading ="formUpload.mainImg[0].loading"
                                        @click="clickInputMain()"
                                        >Change Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                                 <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                                <input type="file" :name="uploadFieldName" style="display:none" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, -1); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput1">
                                </form>
                         
                      </v-flex>
                  </v-layout>
                  <v-layout row  class="  pl-2 pr-2 white  ">
                      <v-flex xs12 sm12   class="text-xs-center mr-3 ml-3">
                          <v-text-field class=" "
                          name="title"
                          label="Title of Artefact"
                          id="title"
                          v-model = "formUpload.title[lang]"
                          :rules="titleRules"
                          required
                          >
                          </v-text-field>
                      </v-flex>
                      </v-layout>
                      <v-layout row  class="  pl-2 pr-2 white  ">
               <v-flex xs12 sm12 class="text-xs-center mr-3 ml-3">
                          <v-text-field class=" "
                          name="description"
                          label="Description of Artefact"
                          id="description"
                          v-model = "formUpload.description[lang]"
                          :rules="titleRules"
                          required
                          multi-line
                          >
                          </v-text-field>
                      </v-flex>


                      
                  </v-layout>
                  <v-layout row align-center  class="white">
   
          <v-flex xs12 sm12 >
           
            <v-checkbox v-model="formUpload.showDate" class="ml-3 pt-3" label="Historical Date"></v-checkbox>
          
      <v-date-picker color="green lighten-1" v-if="formUpload.showDate"  :locale="lang" style="width:100%;" header-color="primary" v-model="formUpload.date"></v-date-picker>
          </v-flex>
                  </v-layout>
                      

                          <v-card color=""  style="box-shadow: none" >
                              <v-card-text >
                                <v-container fluid class="pa-0" >
                                  <v-layout justify-center row  wrap class="pr-2 pl-2 pa-0 white " >
                                    <v-flex xs12 sm12 md12 class="text-xs-center ">
                                      
                                                            <v-select
              label="Name of Groups"
             v-bind:items="collections"
              :item-text="'title'+'['+lang+']'"
              item-value="title.en"
              v-model="formUpload.collectionId"
              multiple
              chips
         
              persistent-hint
            >
            
            
            
            </v-select>
                             
                                      
                                      
                                      <!-- <v-select
                                    
                                        label="Name of Collection"
                                        chips
                                        tags
                                        :items="collections"
                                        item-text = "title"
                                        item-value="title"
                                        :rules="selectRules"
                                        v-model="formUpload.collectionId"
                                        ref="tags"
                                        required
                                        
                                      >
                                        <template slot="selection" slot-scope="data">
                                          <v-chip
                                            @input="data.parent.selectItem(data.item)"
                                            class="chipelect-multi"
                                            :selected="data.selected"
                                            :disabled="data.disabled"
                                            :key="JSON.stringify(data.item)"
                                          >
                                            <v-avatar class="primary">{{ data.item.slice(0, 1).toUpperCase() }}</v-avatar>
                                            {{ data.item }}
                                          </v-chip>
                                        </template>
                                      </v-select> -->
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card-text>
                            </v-card>
                      
                </div>

  <v-card height="415px" class="pa-3 map noBoxShadow"  elevation-1>
  <web-location-picker @newLocation="newLocationMethod" @newMarker="$emit('newMarker',$event)" :marker="marker" :place="place" :center="center" :new="newLocation" ></web-location-picker>
  </v-card>
              



</v-flex>

<v-flex xs12 md8 style="position:relative">

  <div class=" " style="height:100%;position:relative">

  <v-layout row class="hidden-sm-and-down pl-3 pt-3" style="height:67px;">
  <v-flex xs12>
  <p style="color:grey; font-size:1.2em"> <v-icon large>info </v-icon>  <i> To add more info, press <v-icon>add_box </v-icon>, then press <v-icon>save </v-icon> to save the artefact! </i> </p>
    </v-flex> </v-layout>  <v-divider> </v-divider>


<!-- <v-layout row wrap justify-center class=""> -->
       <div style=""  v-for="(media, index) in formUpload.uploads" :key="media._id">

      <!-- <v-flex xs4>
        <div style="position:relative; " class="container-image myImg" v-on:resize="handleSize()">
        <img class="variableWidth myImg ma-1"  v-on:resize="handleSize()" style="padding-left:2px; padding-right:2px" :src="media.data[0].url" alt="">
        <div class="middle myImg" v-on:resize="handleSize()">
          <v-btn fab small dark color="black">
            <v-icon>edit</v-icon>
          </v-btn>

          <v-btn fab small dark color="black">
            <v-icon>delete</v-icon>
          </v-btn>
        </div>
        </div>
      </v-flex> -->

      <v-flex xs12  v-if="media.type ==='image'"> 
        <div v-if="media.data.length == 0">
              <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout row wrap justify-center elevation-1 class="mt-2 mb-2 pl-2 pr-2 pt-2 pb-2 white">
                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn
                                        style="width:85%"
                                        color="primary"
                                        class="white--text"
                                         v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                        @click="clickInput('ref'+index)"
                                        >Upload an Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
        <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="'ref'+index" @change="filesChange($event.target.name, $event.target.files,index); fileCount = $event.target.files.length" accept="image/*" class="input-file">
      </form>
                         
                     </v-flex>

                     <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon  dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                  </v-layout>
                  </v-flex>
                  </v-layout>
        </div>




      <div v-else  class=" position:relative" style=" "  >
        <!-- <div style="position:absolute; left:9%; top: 20px;">
          <v-btn v-on:click="appear(editImage, index)" fab small dark color="black">
            <v-icon>edit</v-icon>
          </v-btn>

          <v-btn @click="deleteUpload(index)" fab small dark color="black">
            <v-icon>delete</v-icon>
          </v-btn>
        </div>
        <div  v-if="editImage[index]">
        <div class="overlayImageOnEdit">
            <v-layout row  class="mt-2  pl-2 pr-2 pt-2 pb-2 " style="    top: 35%;
    position: relative;">
                      <v-flex xs12 sm8 offset-sm2 class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn  style="width:215px; top:20%"
                                        color="white"
                                        class="black--text"
                                        @click="clickInput('ref'+index)"
                                        >Change  Image 
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                                 <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                                <input type="file" :id="'ref'+index" :name="uploadFieldName" style="" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput1">
                                </form>
                         
                      </v-flex>
                  </v-layout>
      </div>
      </div> -->


       <v-layout justify-center  >
                      <v-flex xs12 md11 >
                        <v-layout elevation-1 class="mt-3 mb-3">
                          <v-flex xs12>

      <v-layout row class="mt-2 mb-2 pl-2 pr-2 justify-center pt-2 pb-2 white hidden-sm-and-down">
                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="primary"
                                          v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                        @click="clickInput('ref'+index)"
                                        >Change  Image 
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                                 <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                                <input type="file" :id="'ref'+index" :name="uploadFieldName" style="" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput1">
                                </form>
                         
                      </v-flex>

                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                        >Delete
                                        <v-icon right dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                    

                      </v-layout>

                      <v-layout row  class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-md-and-up">
                      <v-flex xs12 sm6 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="primary"
                                         v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                     
                                         @click="clickInput(media.positionRef)"
                                >
                                        <v-icon  dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="media.positionRef" @change="filesChange($event.target.name, $event.target.files, media.position); fileCount = $event.target.files.length" accept="audio/*" class="input-file" >
      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm6 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon  dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                    

                      </v-layout>
          <img style="width: 100%" :src="media.data[0].url" alt="">

          </v-flex>
                  </v-layout>
</v-flex>
                        </v-layout>
        

      </div>
  
      </v-flex>

      
      <v-flex 1 v-else-if="media.type === 'video'">
        <!-- <v-card>
  
         <div v-if="media.data.length != 0">
        <v-card-media>
      <div  class="" style="" >
        <d-player :video='{
                url: media.data[0].url,
                  }'
                :autoplay="false"
                :contextmenu="contextmenu"
                screenshot: true
                lang = "en"
                @play="play"
                ref="player">
        </d-player >  
      </div>
      </v-card-media>
  
      <v-layout row class="text-xs-center pb-2" center justify-center>
        <v-btn style="width: 27px;
    height: 27px;"  
     @click="clickInput('ref'+index)"
    dark color="black">
        <v-icon> edit </v-icon>
      </v-btn>
      <v-btn style="width: 27px;
    height: 27px;"  dark @click="deleteUpload(index)" color="black">
        <v-icon> delete </v-icon>
      </v-btn>
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
 <input type="file" :id="'ref'+index" :name="uploadFieldName" style="" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="video/*" class="input-file" ref="fileInput1">
 </form>
      </v-layout>
      </div>
      <div v-else>
                        <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2 pt-2 pb-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:215px;"
                                        color="primary"
                                       
                                        class="white--text"
                                        @click="clickInput('ref'+index)"
                                        >Upload a Video
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                                       <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                            <input type="file" :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="video/*" class="input-file">
                                      </form>
                          
                      </v-flex>
                  </v-layout>
      </div>
      </v-card> -->










 <!-- FOR DESKTOP -->
                      <div class="">
                        <div v-if="media.data.length >0">
                      <v-layout justify-center  >
                      <v-flex xs12 md11 >
                        <v-layout elevation-1 class="mt-3 mb-3">
                          <v-flex xs12>

                          
                        <v-layout row justify-center class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-sm-and-down">
                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                     
                                         @click="clickInput('ref'+index)"
                                        >Change Video File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                            <input type="file" :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="video/*" class="input-file">
                                      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                        >Delete
                                        <v-icon right dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                    

                      </v-layout>

                      <v-layout row  class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-md-and-up">
                      <v-flex xs12 sm6 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="primary"
                                           v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                     
                                         @click="clickInput('ref'+index)"
                                      
                                >
                                        <v-icon  dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
             <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                            <input type="file" :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="video/*" class="input-file">
                                      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm6 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon  dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                    

                      </v-layout>
      
       
      <v-card>
         <div >
        <v-card-media>
      <div  class=""  >
        <!-- <d-player :video='{
                url: media.data[0].url,
                  }'
                :autoplay="false"
                :contextmenu="contextmenu"
                screenshot: true
                lang = "en"
                @play="play"
                ref="player">
        </d-player >   -->

        <video style="width:100%; height:100%" controls  >
  <source :src="media.data[0].url + '.mp4'" type="video/mp4">
  <source :src="media.data[0].url + '.webm'" type="video/webm">
  <source :src="media.data[0].url + '.m4v'" type="video/m4v">
  <source :src="media.data[0].url + '.ogg'" type="video/ogg">
Your browser does not support the video tag.
</video>
      </div>
      </v-card-media> 
      </div>    
      </v-card>
                     
                  
                  </v-flex>
                  </v-layout>
</v-flex>
                        </v-layout>

                  
                      </div>

                      <div v-else>
                      <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout row wrap justify-center elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm5 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:85%"
                                        color="primary"
                                       
                                           v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                        @click="clickInput('ref'+index)"
                                        >Upload a Video
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                                       <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                            <input type="file" :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="video/*" class="input-file">
                                      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon  dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                  </v-layout>
                  </v-flex>
                  </v-layout>
                      </div>
                      </div>
                      
                    <!-- FOR MOBILE -->
                    <!-- <div class="hidden-md-and-up">
                      <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:85%;"
                                        color="primary"
                                        class="white--text"
                                         v-bind:class="{ 'green darken-3' : media.status }"
                                        @click="clickInput(media.positionRef)"
                                        >Upload a Video File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file"  :name="uploadFieldName" :id="media.positionRef" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files,media.position); fileCount = $event.target.files.length" accept="application/pdf" class="input-file">
      </form>
                          
                      </v-flex>
                  </v-layout>
                  </v-flex>
                  </v-layout>
                    </div>
                  -->


































      </v-flex>

    
      <v-flex  v-else-if="media.type === 'audio'">
            <!-- <div v-if="media.data.length != 0">  
      <v-layout row>

      <v-layout  class="">
      
      <div  class="" style="" >
        <a-player elevation-0 style="    box-shadow: 0 0 0 0;" :music="{
                            title: media.data[0].originalName,
                            author: ' ',
                            url: media.data[0].url,
                            pic: 'http://lectii-photoshop.com/wp-content/uploads/photo-shop/Lectii_Articole/Grafica%20pentru%20site/Music%20Icon/Music%20Icon-31.jpg',
                            }">
        </a-player>
      </div>
      </v-layout>



      
       <div class="">
        <v-btn style="width: 27px;
    height: 27px;" fab 
    @click="clickInput('ref'+index)"
    small dark color="black">
        <v-icon> edit </v-icon>
      </v-btn> <br>
      <v-btn @click="deleteUpload(index)" style="width: 27px;
    height: 27px;" fab small dark color="black">
        <v-icon> delete </v-icon>
      </v-btn>
      </div>
      </v-layout>
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="'ref'+index" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="audio/*" class="input-file" >
      </form>
         </div>
         <div v-else>
             <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:215px;"
                                        color="primary"
                                        class="white--text"
                                      
                                        @click="clickInput('ref'+index)"
                                        >Upload Audio File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file"  :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files,index); fileCount = $event.target.files.length" accept="audio/*" class="input-file">
      </form>
                          
                      </v-flex>
                  </v-layout>
         </div> -->












<!-- FOR DESKTOP -->
                      <div class="">
                        <div v-if="media.data.length >0">
                      <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout elevation-1 class="mt-3 mb-3" style="background-color: #FAFAFA;">
                          <v-flex xs12>
                        <v-layout style="background-color: #FAFAFA;" row justify-center class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2  hidden-sm-and-down">
                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="primary"
                                           v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                     
    @click="clickInput('ref'+index)"
                                
                                        >Change Audio File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
             <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="'ref'+index" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="audio/*" class="input-file" >
      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                        >Delete
                                        <v-icon right dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                    

                      </v-layout>
                          

                      <v-layout row  class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-md-and-up">
                      <v-flex xs12 sm6 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="primary"
                                           v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                     
    @click="clickInput('ref'+index)"
                                       
                                >
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="media.positionRef" @change="filesChange($event.target.name, $event.target.files, media.position); fileCount = $event.target.files.length" accept="audio/*" class="input-file" >
      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm6 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon right dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                    

                      </v-layout>
                      <v-layout row>
                           <v-flex xs12 sm12>
    <!-- from artefact single -->




              <v-layout row  class="pa-1" style="background-color:#FAFAFA">
                        <div style="width:100%; background-color:#FAFAFA">
              <v-layout class="" row style="width:100%; white-space:normal; ">
                         <v-flex xs12>
                             <p> <i>{{media.data[0].originalName}}</i> </p>
                   </v-flex>
                </v-layout>

               <v-layout row>
              <v-flex xs12>
                    <audio controls style="width:100%; ">
                             <source :src="media.data[0].url" type="audio/ogg">
                            <source :src="media.data[0].url" type="audio/mpeg">
                                Your browser does not support the audio element.
                    </audio>
           </v-flex>
           
        

            </v-layout>
                </div>
            </v-layout>

            </v-flex>
                        </v-layout>








      
      
      
      
      </v-flex>






                      </v-layout>

                     
                  
                  </v-flex>
                  </v-layout>
                      </div>

                      <div v-else>
                      <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout row wrap justify-center elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm5  class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:85%;"
                                        color="primary"
                                           v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                        
                                         @click="clickInput('ref'+index)"
                                        >Upload Audio File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file"  :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files,index); fileCount = $event.target.files.length" accept="audio/*" class="input-file">
      </form>
                          
                      </v-flex>
                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon  dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                  </v-layout>
                  </v-flex>
                  </v-layout>
                      </div>
                      </div>
                      
                    <!-- FOR MOBILE -->
                    <!-- <div class="hidden-md-and-up">
                      <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm6 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:85%;"
                                        color="primary"
                                        class="white--text"
                                         v-bind:class="{ 'green darken-3' : media.status }"
                                         @click="clickInput(media.positionRef)"
                                        >Upload Audio File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="media.positionRef" @change="filesChange($event.target.name, $event.target.files, media.position); fileCount = $event.target.files.length" accept="audio/*" class="input-file" >
      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm6 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon  dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                  </v-layout>
                  </v-flex>
                  </v-layout>
                    </div> -->




























      </v-flex>

      
      <v-flex  v-else-if="media.type === 'pdf'">
          <!-- <div v-if="media.data.length != 0">  
      <v-layout row>
      <v-layout  class="">
      <div  class="pt-2" style="" >
        <v-layout row>
          <div class=" ml-3 mb-3 mt-2 pa-1 mr-3 icon-circle primary text-xs-center" style="">
              <v-btn small fab primary  :href="media.data[0].url" download><v-icon dark >picture_as_pdf</v-icon></v-btn>
          </div>
          <div>
            <a class="pdfText"> <b>{{media.data[0].originalName}}</b></a> <br>
            <p class="pdfDate">{{formUpload.meta.creationDate | date}}</p>
        </div>   
      </v-layout>
      </div>
      </v-layout>
      
      <div class="">
        <v-btn style="width: 27px;
    height: 27px;" fab
       @click="clickInput('ref'+index)"
     small dark color="black">
        <v-icon> edit </v-icon>
      </v-btn> <br>
      <v-btn @click="deleteUpload(index)" style="width: 27px;
    height: 27px;" fab small dark color="black">
        <v-icon> delete </v-icon>
      </v-btn>
      </div>
      </v-layout>
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="'ref'+index" @change="filesChange($event.target.name, $event.target.files, index); fileCount = $event.target.files.length" accept="pdf/*" class="input-file" >
      </form>
          </div>
          <div v-else>
          
           <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:215px;"
                                        color="primary"
                                        class="white--text"
                                       
                                        @click="clickInput('ref'+index)"
                                        >Upload a PDF File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file"  :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files,index); fileCount = $event.target.files.length" accept="application/pdf" class="input-file">
      </form>
                          
                      </v-flex>
                  </v-layout>
        
          </div> -->





         <!-- FOR DESKTOP -->
                      <div class="hidden-sm-and-down">
                        <div v-if="media.data.length >0">
                      <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout elevation-1 class="mt-3 mb-3 pl-2 pr-2  pt-2 pb-2 white">
                          <v-flex xs12>
                        <v-layout row  >
                      <v-flex xs12 sm12 class="text-xs-center mr-3 ml-3">
                          
                                  <v-btn
                                        style="width:85%"
                                        color="primary"
                                           v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                       
                                        @click="clickInput('ref'+index)"
                                        >Change PDF File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file"  :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files,index); fileCount = $event.target.files.length" accept="application/pdf" class="input-file">
      </form>
                          
                      </v-flex>
                    

                      </v-layout>

                      <v-layout row>
                           <v-flex xs12 sm12>
      <v-card>
          <v-list two-line>
              <v-list-tile >
            <v-list-tile-avatar >
              <v-icon class="blue white--text"> picture_as_pdf</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{media.data[0].originalName}}</v-list-tile-title>
              <!-- <v-list-tile-sub-title>{{artefact.meta.creationDate | date}}</v-list-tile-sub-title> -->
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn @click="deleteUpload(index)"  icon ripple>
                <v-icon  color="grey lighten-1">delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          </v-list>
      </v-card></v-flex>
                      </v-layout>
                      </v-flex>
                      </v-layout>
                      

                     
                  
                  </v-flex>
                  </v-layout>
                      </div>

                      <div v-else>
                      <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout row wrap justify-center elevation-1 class="mt-3 mb-3 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:85%;"
                                        color="primary"
                                           v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                    
                                        @click="clickInput('ref'+index)"
                                        >Upload a PDF File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file"  :name="uploadFieldName" :id="'ref'+index" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files,index); fileCount = $event.target.files.length" accept="application/pdf" class="input-file">
      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm5 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon  dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                  </v-layout>
                  </v-flex>
                  </v-layout>
                      </div>
                      </div>
                      
                    <!-- FOR MOBILE -->
                    <div class="hidden-md-and-up">
                      <v-layout justify-center>
                      <v-flex xs12 md11 >
                        <v-layout row wrap justify-center elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm6  class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:85%;"
                                        color="primary"
                                        class="white--text"
                                            v-bind:class="{ 'green darken-3' : media.status }"
                                         :loading = "media.loading"
                                        @click="clickInput(media.positionRef)"
                                        >Upload a PDF File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file"  :name="uploadFieldName" :id="media.positionRef" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files,media.position); fileCount = $event.target.files.length" accept="application/pdf" class="input-file">
      </form>
                          
                      </v-flex>

                      <v-flex xs12 sm6 class="text-xs-center mr-3 ml-3">
                          
                                <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                         v-bind:class="{ 'red darken-3' : media.status }"
                                         @click="deleteUpload(index)"
                       
                                       >
                                        <v-icon  dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
          
                          
                      </v-flex>
                  </v-layout>
                  </v-flex>

                  
                  </v-layout>
                    </div>










      </v-flex>

      
      <v-flex  v-else-if="media.type === 'text'">
      

      <!-- <v-layout elevation-1> -->

      <!-- <v-layout row  class="  pl-2 pr-2 white  ">
               <v-flex xs12 sm12 class="text-xs-center mr-3 ml-3">
                          <v-text-field class=" "
                          name="upload text"
                          label="Text Paragraph"
                          id="upload_text"
                          v-model = "media.value"
                          :rules="titleRules"
                  
                          multi-line
                          >
                          </v-text-field>
                      </v-flex>
                  </v-layout> -->

                  <v-layout justify-center>
                      <v-flex xs12 md11 >
                       <v-layout row wrap elevation-1 class="mt-2 mb-2 pl-2 pr-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          <!-- <v-text-field 
                          name="description"
                          label="Text Input"
                          id="description"
                          multi-line
                          v-model="media.value"
                          >
                          </v-text-field> -->
                          <!-- <medium-editor class="mediumEditor pa-3" :options='options' :text="media.value" v-on:edit='applyTextEdit(index,$event)' custom-tag='div'></medium-editor> -->
                      
                      <quill-editor class="editor-example bubble"
                      ref="myTextEditor"
                      v-model="media.value[lang]"
                      :options="editorOption">
        </quill-editor>
                      
                      </v-flex>

                      <v-flex xs12   class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:85%;"
                                        color="red darken-2"
                                        class="white--text"
                                      @click="deleteUpload(index)"
                                        
                                        >Delete
                                        <v-icon right dark>
                                            delete_forever
                                        </v-icon>
                                 </v-btn>
           
                          
                      </v-flex>
                  </v-layout>
                  </v-flex>
                  </v-layout>
      
   
  
      </v-flex>

      

   
       </div>
<!-- </v-layout> -->









<!-- 
  




                
                  <div v-for="item in formUpload.uploads" :key="item.key" >
                    <div v-if="item.type === 'text' ">
                       <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          <v-text-field 
                          name="description"
                          label="Text Input"
                          id="description"
                          multi-line
                          v-model="item.value"
                          >
                          </v-text-field>
                      </v-flex>
                  </v-layout>
                    </div>
                      <div v-else-if="item.type === 'video' ">
                     <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2 pt-2 pb-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:215px;"
                                        color="primary"
                                         v-bind:class="{ 'green darken-3' : item.status }"
                                        class="white--text"
                                        @click="clickInput(item.positionRef)"
                                        >Upload a Video
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                                       <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                            <input type="file" :name="uploadFieldName" :id="item.positionRef" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, item.position); fileCount = $event.target.files.length" accept="video/*" class="input-file">
                                      </form>
                          
                      </v-flex>
                  </v-layout>
                    </div>
                    <div v-else-if="item.type === 'audio' ">
                       <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:215px;"
                                        color="primary"
                                        class="white--text"
                                         v-bind:class="{ 'green darken-3' : item.status }"
                                         @click="clickInput(item.positionRef)"
                                        >Upload Audio File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="item.positionRef" @change="filesChange($event.target.name, $event.target.files, item.position); fileCount = $event.target.files.length" accept="audio/*" class="input-file" >
      </form>
                          
                      </v-flex>
                  </v-layout>
                    </div>
                    <div v-else-if="item.type === 'pdf' ">
                        <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                          
                                 <v-btn
                                        style="width:215px;"
                                        color="primary"
                                        class="white--text"
                                         v-bind:class="{ 'green darken-3' : item.status }"
                                        @click="clickInput(item.positionRef)"
                                        >Upload a PDF File
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file"  :name="uploadFieldName" :id="item.positionRef" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files,item.position); fileCount = $event.target.files.length" accept="application/pdf" class="input-file">
      </form>
                          
                      </v-flex>
                  </v-layout>
                    </div>
                    <div v-else-if="item.type === 'image' ">
                        <v-layout row elevation-1 class="mt-2 mb-2 pl-2 pr-2 pt-2 pb-2 white">
                      <v-flex xs12 sm12 offset-sm2 class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn
                                        style="width:215px;"
                                        color="primary"
                                        class="white--text"
                                         v-bind:class="{ 'green darken-3' : item.status }"
                                        @click="clickInput(item.positionRef)"
                                        >Upload an Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
        <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" :id="item.positionRef" @change="filesChange($event.target.name, $event.target.files,item.position); fileCount = $event.target.files.length" accept="image/*" class="input-file">
      </form>
                         
                      </v-flex>
                  </v-layout>
                    </div>
                  </div> -->





<v-layout row style="position:relative" class="">

<v-flex xs10>
    <div style="position:relative; bottom:0%; left:0%"> <v-speed-dial class="hidden-sm-and-down pl-4 ml-5 mt-5" style="width:100px"
      v-model="fab1"
      :top="top1"
      :bottom="bottom1"
      :right="right1"
      :left="left1"
      :direction="direction1"
      :hover="hover1"
      :transition="transition1"
     
    >
      <v-btn class="ma-1"
        slot="activator"
        color="primary"
        dark
        fab
        hover
        v-model="fab1"
      >
        <v-icon>add_box</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addTextToUploads"
      >
        <v-icon>text_fields</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addImageToUploads"
        
      >
        <v-icon>photo_library</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addVideoToUploads"
      >
        <v-icon>video_library</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addAudioToUploads"
        
      >
        <v-icon>library_music</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addPdfToUploads"
        
      >
        <v-icon>picture_as_pdf</v-icon>
      </v-btn>
    </v-speed-dial> </div>


    </v-flex>

    <v-flex xs2>


    <div style="position:relative; bottom:0%; right:0%"> <v-speed-dial class="hidden-md-and-up mt-5" style=""

      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right2"
      :left="left2"
      :direction="direction2"
      :hover="hover"
      :transition="transition"
      fixed
      id="bottom_button1"
 
     
    >
      <v-btn  v-if="formUpload.description[lang].length > 0 && formUpload.title[lang].length > 0 && formUpload.mainImg[0].url && isReady" class="ma-1"
        slot="activator"
        color="red"
        dark
        fab
        hover
        v-model="fab"
        type = "submit"
        @click="btnSubmit=!btnSubmit"
      >
        <v-icon>save</v-icon>

      </v-btn>

      <v-btn v-else class="ma-1"
       
        slot="actixdscvator"
        color="grey darken-2"
        dark
        fab
        hover
        v-model="fab"
      >
        <v-icon>save</v-icon>

      </v-btn>
   
    </v-speed-dial> </div>

    <div style="position:relative; bottom:0%; right:0%"> <v-speed-dial class="hidden-sm-and-down pr-3 mr-3 mt-5" style="width:100px"

      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right2"
      :left="left2"
      :direction="direction2"
      :hover="hover"
      :transition="transition"
      fixed
      id="bottom_button1"
 
     
    >
      <v-btn  v-if="formUpload.description[lang].length > 0 && formUpload.title[lang].length > 0 && formUpload.mainImg[0].url && isReady" class="ma-1"
        slot="activator"
        color="red"
        dark
        fab
        hover
        v-model="fab"
        type = "submit"
        @click="btnSubmit=!btnSubmit"
      >
        <v-icon>save</v-icon>

      </v-btn>

      <v-btn v-else class="ma-1"
        @click.native="snackbar = true"
        slot="activator"
        color="grey darken-2"
        dark
        fab
        hover
        v-model="fab"
      >
        <v-icon>save</v-icon>

      </v-btn>
   
    </v-speed-dial> </div>

    </v-flex>

<v-snackbar
      :timeout="timeout"
      color="red"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      Required fields must be completed
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>

 </v-layout>




  </div>

                  </v-flex>
                  </v-layout>

                 
                  
                  <!-- <v-layout row>
                      <v-flex v-if="formUpload.description.length > 0 && formUpload.title.length > 0 && formUpload.mainImg[0].url" xs12 sm8 offset-sm2 class="text-xs-center hidden-md-and-up mt-2">
                          <v-btn 
                          type = "submit"
                          color="primary"
                          @click="btnSubmit=!btnSubmit"
                          >Save Changes
                          </v-btn>
                      </v-flex>
                      <v-flex v-else xs12 sm8 offset-sm2 class="text-xs-center hidden-md-and-up mt-2">
                          <v-btn 
                          disabled
                          color="primary"
                          >Save Changes
                          </v-btn>
                      </v-flex>
                  </v-layout> -->
              </v-form>
              <v-layout row class="pl-6" > 
                  <v-speed-dial id="bottom_button" class="hidden-md-and-up"
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :hover="hover"
      :transition="transition"
      fixed
    >
      <v-btn class="ma-1"
        slot="activator"
        color="primary"
        dark
        fab
        hover
        v-model="fab"
      >
        <v-icon>add</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addTextToUploads"
      >
        <v-icon>text_fields</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addImageToUploads"
        
      >
        <v-icon>photo_library</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addVideoToUploads"
      >
        <v-icon>video_library</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addAudioToUploads"
        
      >
        <v-icon>library_music</v-icon>
      </v-btn>
      <v-btn class="ma-1"
        fab
        dark
        small
        color="grey darken-2"
        @click="addPdfToUploads"
        
      >
        <v-icon>picture_as_pdf</v-icon>
      </v-btn>
    </v-speed-dial>
              </v-layout>
          </v-flex>
      </v-layout>
       <div class="container">

  </div>
  </v-container>
 </v-card>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import hljs from "highlight.js";
import VueAplayer from "vue-aplayer";
import editor from "vue2-medium-editor";
import VueDPlayer from "vue-dplayer";
import { upload } from "@/components/FileUpload/file-upload.service";
import axios from "axios";
import Vue from "vue";
const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;
export default {
  props: ["formUpload", "lang", "place", "center", "marker", "newLocation"],
  data() {
    return {
      name: "02-example",
      content: "",
      editorOption: {
        theme: "bubble",
        placeholder: "Type your text...",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"]
          ]
        }
      },
      mode: "",
      options: {
        toolbar: {
          buttons: [
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "h4",
            "h3",
            "h2",
            "justifyRight",
            "justifyLeft",
            "justifyCenter",
            "orderedlist",
            "unorderedlist"
          ]
        },
        anchor: {
          /* These are the default options for anchor form,
           if nothing is passed this is what it used */
          // customClassOption: 'alink',
          // customClassOptionText: 'Button',
          // linkValidation: false,
          // placeholderText: 'YOYOYO',
          // targetCheckbox: false,
          // targetCheckboxText: 'Open in new window'
        }
      },
      isClicked: false,
      editImage: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      textval: "",
      i: -1,
      valid: true,
      title: "",
      location: "",
      description: "",
      imageUrl: "",
      youtubeLink: "",
      date: new Date(),
      time: new Date(),
      direction2: "left",
      direction: "right",
      fab: false,
      fling: false,
      hover: false,
      snackbar: false,
      timeout: 6000,
      tabs: null,
      top: false,
      right2: true,
      bottom: true,
      left2: false,
      right: false,
      left: true,
      transition: "slide-y-reverse-transition",
      direction1: "right",
      fab1: false,
      fling1: false,
      hover1: false,
      tabs1: null,
      top1: false,
      right1: true,
      bottom1: true,
      left1: false,
      transition1: "slide-y-reverse-transition",
      select: null,
      tags: ["Programming", "Vue", "Vuex"],
      titleRules: [v => !!v || "Title is required"],
      descriptionRules: [v => !!v || "Description is required"],
      selectRules: [v => !!v || "Collections are required"],
      uploads: [],
      btnSubmit: false,
      contextmenu: [
        {
          text: "Download Video",
          link: "https://github.com/MoePlayer/vue-dplayer"
        }
      ],
      player: null,
      music: {}
    };
  },

  watch: {
    formUpload(val) {
      if (val.date == undefined || val.date == "Invalid Date") {
        this.formUpload.date = new Date(new Date(Date.now()).getTime());
      } else this.formUpload.date = new Date(new Date(val.date).getTime());
    },
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    }
  },
  components: {
    "a-player": VueAplayer,
    "d-player": VueDPlayer,
    "medium-editor": editor,
    quillEditor
  },

  computed: {
    isMod() {
      return this.$store.getters.isMod;
    },
    contentCode() {
      return hljs.highlightAuto(this.content).value;
    },
    editor() {
      return this.$refs.myTextEditor.quill;
    },
    isReady() {
      for (var files of this.formUpload.uploads)
        if (files.type != "text") if (!files.data[0]) return false;
      return true;
    },
    token() {
      return this.$store.getters.getToken;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isAuthor() {
      return this.formUpload.userId == this.user._id;
    },
    user() {
      return this.$store.getters.getUser;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    formIsValid() {
      return this.title[this.lang] !== "" && this.description[this.lang] !== "";
    },
    activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    },

    // formUpload() {
    //   return this.$store.getters.loadArtefactSingle(this.id);
    // },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    collections() {
      return this.$store.getters.loadAllCollections;
    }
  },
  submittableDateTime() {
    const date = new Date(this.date);

    return date;
  },
  methods: {
    newLocationMethod(location) {
      this.formUpload.location = location;
      this.$emit("newLocation", location);
    },
    onEditorChange({ editor, html, text }) {
      console.log("editor change!", editor, html, text);
      this.content = html;
    },
    applyTextEdit(index, ev) {
      if (ev.event.target) {
        this.formUpload.uploads[index].value = ev.event.target.innerHTML;
      }
    },
    deleteUpload(position) {
      var index = this.formUpload.uploads.indexOf(position);

      this.formUpload.uploads.splice(position, 1);
    },
    appear(variable, index) {
      Vue.set(this.editImage, index, !this.editImage[index]);
    },
    shouldAppear: function(variable, index) {
      if (variable[index] === true) return true;
      else return false;
    },
    displayArray(x) {
      for (var i = 0; i < x.length; i++) {}
    },
    play() {},
    addTextToUploads() {
      this.i++;
      const data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "text",
        status: 0,
        key: "",
        value: {
          en: "",
          sr: "",
          ro: ""
        }
      };
      this.formUpload.uploads.push(data);
    },

    addImageToUploads() {
      this.i++;
      const data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "image",
        status: 0,
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    addPdfToUploads() {
      this.i++;
      const data = {
        position: this.i,
        positionRef: "ref" + this.i,
        status: 0,
        type: "pdf",
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    addAudioToUploads() {
      this.i++;
      const data = {
        status: 0,
        position: this.i,
        positionRef: "ref" + this.i,
        type: "audio",
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    addVideoToUploads() {
      this.i++;
      const data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "video",
        status: 0,
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    clickInput(position) {
      var element = document.getElementById(position);

      element.click();
    },
    clickInputMain() {
      this.$refs.fileInput1.click();
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData, position) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      if (position == -1) this.formUpload.mainImg[0].loading = true;
      else this.formUpload.uploads[position].loading = true;
      upload(formData, this.user._id)
        .then(x => {
          if (position == -1) {
            this.formUpload.mainImg = x;
            this.formUpload.mainImg[0].status = 1;
            this.formUpload.mainImg[0].loading = false;
          } else {
            this.formUpload.uploads[position].data = x;
            this.formUpload.uploads[position].status = 1;
            this.formUpload.uploads[position].loading = false;
          }
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch(err => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    filesChange(fieldName, fileList, position) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData, position);
    },
    onCreateArtefact() {
      this.$store.dispatch("createArtefact", this.formUpload);
      this.$router.push("/artefacts");
    },
    onUpdateArtefact() {
      this.$emit("maybe");
    },
    moveButton(admin) {
      if (admin) {
        var btn = document.getElementById("bottom_button");
        btn.style.bottom = "65px";
      } else {
        var btn = document.getElementById("bottom_button");
        btn.style.bottom = "15px";
      }
    },
    moveButton1(admin) {
      if (admin) {
        var btn = document.getElementById("bottom_button1");
        btn.style.bottom = "65px";
      } else {
        var btn = document.getElementById("bottom_button1");
        btn.style.bottom = "15px";
      }
    },
    handleSize() {
      // var img = document.getElementsByClassName('myImg');
      // console.log(img[0]);
      // var i= 0;
      // for(i = 0; i < img.length;i++)
      // {
      // img[i].style.width = screen.width / 3.3 + 'px';
      // var height = img[i].style.width;
      // img[i].style.height = height ;
      // }
      // var video = document.getElementById('video');
      // video.style.width = screen.width + 'px';
      // var height = video.style.width;
      // video.style.height = screen.width /2 + 'px';
    }
  },
  updated: function() {
    // this.handleSize();
    this.moveButton(this.isAdmin);
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadUsers");
    this.reset();
    this.moveButton(this.isAdmin);
    this.moveButton1(this.isAdmin);
  },

  created() {
    this.$store.dispatch("loadArtefacts");
    if (!this.isLoggedIn) {
      this.$router.push("/signin");
    } else if (!this.isAuthor && !this.isAdmin && !this.isMod)
      this.$router.push("/");
  }
};
</script>

<style src="@/../node_modules/medium-editor/dist/css/medium-editor.css">
</style>

<style src="@/../node_modules/medium-editor/dist/css/themes/default.css">
</style>

<style scoped>
.noBoxShadow {
  box-shadow: none;
}

.mediumEditor {
  outline: none;
  min-height: 60px;
  text-align: left;
}
</style>


<style>
.input-file {
  display: none;
}
.map {
  position: relative;
}

.map-toolbar {
  position: absolute;
  width: 80%;
}

.toolbar__content {
  position: relative;
  width: 100%;
}

.myImg {
  opacity: 1;
  display: block;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  top: 83%;
  left: 65%;
}

.overlayImageOnEdit {
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.7;
  position: absolute;
  transition: 0.5s ease;
}

.container-image:hover .myImg {
  opacity: 0.5;
}

.container-image:hover .middle {
  opacity: 1;
}

.pdfText {
  text-decoration: none;
  color: black !important;
  outline: none;
}

.pdfDate {
  font-size: 0.8em;
  color: grey;
}
</style>



<style scoped>
.noBoxShadow {
  box-shadow: none;
}
</style>


<style lang="scss" scoped>
.quill-editor,
.quill-code {
  height: 20rem;
}
.quill-editor {
  border: 1px solid #ccc;
  border-bottom: none;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    width: 100%;
    margin: 0;
    padding: 1rem;
    border: 1px solid #ccc;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
  }
}
</style>

<style src='@/../static/quill.bubble.css'>
</style>


// WEBPACK FOOTER //
// src/components/Partials/EditArtefactPartial.vue